module.exports = __webpack_public_path__ + "static/media/88.5c79f8a1.gif";